// The `withdraw_pending_proposal` tool's card (BUILD 2 C2-7, WP2-9 step 7):
// what was withdrawn. The tool never approves anything.
//
import type { WithdrawResult } from '@/voice/contracts';
import { useNamespaceCopy } from '@/i18n/ns';
import voiceConfirmCopy from '@/i18n/ns/voice-confirm';

export function WithdrawCard({ output }: { output: WithdrawResult | undefined }) {
  const copy = useNamespaceCopy(voiceConfirmCopy);
  if (!output)
    return (
      <p className="ws-tool-progress" role="status">
        {copy.working}
      </p>
    );
  return (
    <section className="ws-voice-confirm-card" data-voice-card="withdrawn">
      <h3>{output.status === 'withdrawn' ? copy.withdrawn : copy.errorNotPending}</h3>
    </section>
  );
}
